<template>
  <div
    class="visa-case-item"
    :style="{ 'background-image': 'url(' + caseInfo.cover + ')' }"
    @click="goArticleDetail(caseInfo.id)"
  >
    <div class="case-cover"></div>
    <div class="case-content">
      <div class="case-title">{{ caseInfo.title }}</div>
      <div class="case-desc">{{ caseInfo.summary }}</div>
      <div class="fill-space"></div>
      <div class="bottom-info">
        <div class="viewed"></div>
        <span class="view-count">{{ formatViewecCount(caseInfo.hit) }}</span>
        <div class="time"></div>
        <span class="time-text" v-if="caseInfo.update_time">{{
          caseInfo.update_time.substring(0, 10)
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import knowledgeService from "../../../services/knowledge-service";

export default {
  name: "visa-case-item",
  props: {
    caseInfo: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  methods: {
    formatViewecCount: knowledgeService.formatViewecCount,
    goArticleDetail(id) {
      this.$router.push({ name: "article", params: { id } });
    },
  },
};
</script>

<style lang="less" scoped>
.visa-case-item {
  width: 353px;
  height: 168px;
  border-radius: 2px;
  padding: 18px 16px 20px 16px;
  margin-right: 30px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  cursor: pointer;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center center;
  &:nth-child(3n) {
    margin-right: 0;
  }
  .case-cover {
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border-radius: 2px;
    transition: all 0.3s;
    display: flex;
    background: linear-gradient(
      270deg,
      rgba(243, 246, 249, 0.92) 0%,
      #f3f6f9 49%,
      #f3f6f9 100%
    );
  }
  .case-content {
    position: relative;
    z-index: 2;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .case-title {
      font-size: 18px;
      font-weight: 500;
      color: #2f333d;
      line-height: 25px;
      height: 50px;
      flex-shrink: 0;
    }
    .case-desc {
      margin-top: 8px;
      font-size: 14px;
      font-weight: 400;
      color: #5f666e;
      line-height: 22px;
      height: 44px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .fill-space {
      flex: 1;
    }
    .bottom-info {
      display: flex;
      align-items: center;
      .viewed {
        width: 16px;
        height: 12px;
        background-image: url("../../../assets/imgs/acadmy/view.png");
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% 100%;
      }
      .view-count {
        margin-left: 3px;
        font-size: 14px;
        font-weight: 400;
        color: #91999f;
        line-height: 14px;
      }
      .time {
        margin-left: 20px;
        width: 12px;
        height: 12px;
        background-image: url("../../../assets/imgs/acadmy/time.png");
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% 100%;
      }
      .time-text {
        font-size: 14px;
        font-weight: 400;
        color: #91999f;
        line-height: 14px;
        margin-left: 2px;
      }
    }
  }
  &:hover {
    .case-cover {
      background: linear-gradient(
        270deg,
        rgba(89, 159, 255, 0.92) 0%,
        #599fff 55%,
        #599fff 100%
      );
    }
    .case-content {
      .case-title {
        color: #fff;
      }
      .case-desc {
        color: #fff;
      }
      .bottom-info {
        .viewed {
          background-image: url("../../../assets/imgs/acadmy/view-white.png");
        }
        .time {
          background-image: url("../../../assets/imgs/acadmy/time-white.png");
        }
        .view-count {
          color: #fff;
        }
        .time-text {
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/academy/components/visa-case-item.vue